import { useMutation } from '@tanstack/react-query';
import { extractMenuItemsFromFile } from '../services/menuPrefill';

/** POST /admin/extract-menu-items */
export const useExtractMenuItemsMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (file) => {
      const result = await extractMenuItemsFromFile(file);
      if (!result.success) {
        throw new Error(result.message || 'Failed to extract menu items');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
